module.exports = __webpack_public_path__ + "img/electric-furnace-base.9d0b14cd.png";